import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRolstoelToengankelijk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M18.68 13.7h8.45a2.09 2.09 0 0 1 2.09 2.09v8.45H18.68z"
    />
    <path
      fill="#FF7842"
      d="M10.78 5.21h1.39a1.59 1.59 0 0 1 1.59 1.59v17.44h-3v-19z"
    />
    <path
      fill="#FF7842"
      d="M13.76 6.8v1.12H8.14V5.21h4a1.59 1.59 0 0 1 1.62 1.59M34.5 26.74v-.72a1.13 1.13 0 0 0-1.13-1.13h-5.86a1.13 1.13 0 0 0-1.13 1.13v.72c0 .624.506 1.13 1.13 1.13h5.86a1.13 1.13 0 0 0 1.13-1.13"
    />
    <path
      fill="#FFBFA5"
      d="M18.68 34.78c5.821 0 10.54-4.719 10.54-10.54S24.501 13.7 18.68 13.7 8.14 18.419 8.14 24.24s4.719 10.54 10.54 10.54"
    />
    <path
      fill="#FF7842"
      d="M31.86 34.29a2.64 2.64 0 1 0 0-5.28 2.64 2.64 0 0 0 0 5.28"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.01 13.883A10.05 10.05 0 0 0 6 23.74H5a11.05 11.05 0 1 1 11.05 11.05v-1a10.05 10.05 0 0 0 1.96-19.907"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M16.857 21.762a2.139 2.139 0 1 0-.809 4.118l.004 1a3.14 3.14 0 1 1 3.128-3.14h-1a2.14 2.14 0 0 0-1.323-1.978"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRolstoelToengankelijk);

export default ForwardRef;
